import * as React from 'react';
import { IConfig } from './types/Config.Type';
import { ILoaderProps } from './map/layer/ILoaderProps';
import { OnshoreAquaculture } from './map/layers/pakistan/OnshoreAquaculture';
import { OffshorePompanoAquaculture } from './map/layers/pakistan/OffshorePompanoAquaculture';
import { OffshoreSnapperAquaculture } from './map/layers/pakistan/OffshoreSnapperAquaculture';
import { OffshoreBarramundiAquaculture } from './map/layers/pakistan/OffshoreBarramundiAquaculture';

const Config: IConfig = {
  map: {
    mapKey: "pk.eyJ1IjoibG9uZ2xpbmVlbnZpcm9ubWVudCIsImEiOiJjbGF0cHF1ZWUwM2l0M3FwcDcyN3B1YXpmIn0.snFi9yTPEZ5lfQxE3h3Epg",
    greyStyle: "mapbox://styles/longlineenvironment/clatpsjsl003r15okdwsdclmi",
    satelliteStyle: "mapbox://styles/longlineenvironment/clb14ar2y00hw14oh9ii2zp05",
    longitude: 69, 
    latitude: 31,  
    zoom: 5, 
    minZoom: 5,
    maxZoom: 14,
    bearing: 0,
    pitch: 0,
    max_bounds: [
      [50, 20],    // Southwest (lng/lat)
      [87, 42]     // Northeast (lng/lat)
    ],
  },
  UI: {
    height: 75,
    before_layer: 'waterway-label',
    large_screen: 900,
    load_delay_base: 0,
    load_delay_random: 0,
  },

  suitability: [
    { name: 'Spatial constraints', color: '#aaaaaa', hidden: true },
    { name: 'Not suitable', color: '#dc1010' },
    { name: 'Moderately suitable', color: '#ff6d01' },
    { name: 'Suitable', color: '#128800' },
    { name: 'Highly suitable', color: '#0cf600' },
  ],  

  datasets: [
    {
      key: 'onshore_aquaculture',
      ids: [ 'onshore_aquaculture' ],
      title: 'Onshore aquaculture suitability',
      description: 'Suitability for pond aquaculture (land)',
      active: true,
      group: 'onshore_aquaculture',
      renderer: (p: ILoaderProps) => <OnshoreAquaculture {...p}/>
    }, {
      key: 'offshore_pompano_aquaculture',
      ids: ['offshore_pompano_aquaculture'],
      title: 'Offshore subnose pompano suitability',
      description: 'Suitability areas for subnose pompano cage aquaculture',
      active: false,
      group: 'offshore_aquaculture',
      renderer: (p: ILoaderProps) => <OffshorePompanoAquaculture {...p}/>
    }, {
      key: 'offshore_snapper_aquaculture',
      ids: ['offshore_snapper_aquaculture'],
      title: 'Offshore red snapper suitability',
      description: 'Suitability areas for red snapper cage aquaculture',
      active: false,
      group: 'offshore_aquaculture',
      renderer: (p: ILoaderProps) => <OffshoreSnapperAquaculture {...p}/>
    }, {
      key: 'offshore_barramundi_aquaculture',
      ids: ['offshore_barramundi_aquaculture'],
      title: 'Offshore barramundi suitability',
      description: 'Suitability areas for barramundi cage aquaculture',
      active: false,
      group: 'offshore_aquaculture',
      renderer: (p: ILoaderProps) => <OffshoreBarramundiAquaculture {...p}/>
    }
  ],
  datagroups: [
    {
      key: 'onshore_aquaculture',
      title: 'Onshore aquaculture',
      description: 'Suitability for onshore aquaculture',
      exclusive: true,
    }, {
      key: 'offshore_aquaculture',
      title: 'Offshore aquaculture',
      description: 'Suitability for offshore aquaculture',
      exclusive: true,
    }
  ],
  dictionary: [
    {
      key: 'suitability',
      text: 'Suitability',
      type: 'suitability'
    }, {
      key: 'area_km2',
      text: 'Area',
      unit: <>km&sup2;</>,
      type: 'number',
      factor: 1
    }, {
      key: 'ADM1_EN',
      text: 'Province'
    }
  ]
}

export { Config }
